import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "../translate/translate.module";
import { BadgeTextComponent } from "./components/badge-text/badge-text.component";
import { BadgeComponent } from "./components/badge/badge.component";
import { CounterNumberComponent } from "./components/counter-number/counter-number.component";
import { CounterComponent } from "./components/counter/counter.component";
import { CustomButtonsComponent } from "./components/custom-buttons/custom-buttons.component";
import { CustomPaginatorComponent } from "./components/custom-paginator/custom-paginator.component";
import { LoaderWidgetComponent } from "./components/loader-widget/loader-widget.component";
import { PageSizeSelectComponent } from "./components/page-size-select/page-size-select.component";
import { SmartTableComponent } from "./components/smart-table/smart-table.component";
import { TextCellComponent } from "./components/text-cell/text-cell.component";
import { CellHostDirective } from "./directives/cell-host.directive";
import { RomeDatePipe } from "./pipes/rome-date.pipe";

@NgModule({
  declarations: [
    SmartTableComponent,
    CustomPaginatorComponent,
    BadgeComponent,
    BadgeTextComponent,
    CounterComponent,
    PageSizeSelectComponent,
    CounterNumberComponent,
    CellHostDirective,
    TextCellComponent,
    CustomButtonsComponent,
    LoaderWidgetComponent,
    RomeDatePipe,
  ],
  imports: [
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatTableModule,
    MatSortModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatInputModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  exports: [
    SmartTableComponent,
    BadgeComponent,
    BadgeTextComponent,
    PageSizeSelectComponent,
    CustomPaginatorComponent,
    LoaderWidgetComponent,
  ],
})
export class RecordsModule { }
